import { h, } from "preact";
import { useState, useEffect, useContext } from "preact/hooks";
import { Alert, Box, Button, Chip, Paper, Stack, Typography } from "@mui/material";

import CircularProgressWithLabel from "../Common/CircularProgressWithLabel";
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import { AppContext } from "../../AppContext";
import Dropzone from 'react-dropzone'
import * as UpChunk from '@mux/upchunk';

export default function Uploader({ mode, upperState, max, outerSetState }) {
    //console.log("upperState", upperState)
    const [progress, setProgress] = useState({});
    const [errors, setErrors] = useState({});

    const [clearedFiles, setClearedFiles] = useState([]);
    const [rejectedFiles, setRejectedFiles] = useState([]);

    const app = useContext(AppContext);

    const [currentUploadingFile, setCurrentUploadingFile] = useState(undefined);
    const [filesToFilter, setFilesToFilter] = useState(undefined);
    const [state, setState] = useState("idle");

    const cb_process_queue = useEffect(() => {

        if (state === "upload" && currentUploadingFile === undefined && clearedFiles.length > 0) {
            let undone = clearedFiles.filter((f) => { return f.status === 0 });
            // console.log("undone", undone)
            if (undone.length > 0) {

                var file = undone[0];
                var url;
                var params;



                setCurrentUploadingFile(file)


            } else {
                setState("post_processing");
                app.refPopUp.current.handleChangeState(
                    {
                        opened: true,
                        type: "030",
                        params: {
                            uid: upperState.session_uid,
                            nb: clearedFiles.length,
                            popup_params: upperState.popup_params,
                            failed: rejectedFiles
                        }
                    }
                )
            }
        }

    }, [clearedFiles, currentUploadingFile]);

    const cb_process_one_file = useEffect(() => {
        if (currentUploadingFile !== undefined) {

            const upload = UpChunk.createUpload({
                endpoint: "/upload/re/" + currentUploadingFile.uid,
                file: currentUploadingFile,
                chunkSize: 1024,

            });

            upload.on('error', error => {
                //console.error(error);
                let indx = clearedFiles.findIndex((f) => f.rg === currentUploadingFile.rg);
                let new_file = Object.assign(currentUploadingFile, { status: 2 });
                var files2 = clearedFiles;
                files2.splice(indx, 1, new_file)
                setErrors({ ...errors, [currentUploadingFile.uid]: error.detail })
            });

            upload.on('progress', progr => {
                // console.log("%", progress.detail);
                setProgress({ ...progress, [currentUploadingFile.uid]: progr.detail })
            });

            upload.on('success', () => {
                // console.log("success", files)
                let indx = clearedFiles.findIndex((f) => f.rg === currentUploadingFile.rg);
                let new_file = Object.assign(currentUploadingFile, { status: 1 });
                var files2 = clearedFiles;
                files2.splice(indx, 1, new_file)
                // console.log(files2, indx, new_file, files2.splice(indx, 1, new_file))
                setClearedFiles(files2);
                setCurrentUploadingFile(undefined);

            });
        } else {

        }

    }, [currentUploadingFile]);
    function _arrayBufferToBase64(buffer) {
        var binary = '';
        var bytes = new Uint8Array(buffer);
        var len = bytes.byteLength;
        for (var i = 0; i < len; i++) {
            binary += String.fromCharCode(bytes[i]);
        }
        return window.btoa(binary);
    }
    const cb_cp3 = useEffect(() => {
        console.log("cb_cp3", filesToFilter, clearedFiles, rejectedFiles)
        if (filesToFilter !== undefined && filesToFilter.length > 0) {
            let reader = new FileReader();

            var file = filesToFilter[0];
            reader.readAsArrayBuffer(file.slice(0, 30));
            reader.onload = function () {
                var params;
                switch (mode) {
                    case "docs":

                        params = {
                            digest: _arrayBufferToBase64(reader.result),
                            //    session_uid: upperState.session_uid,
                            target_uid: upperState.target_uid,
                            name: file.name,
                            size: file.size,
                        };

                        break;
                    case "iddoc":

                        var target = upperState.user_id_doc === null ? upperState.user_id_doc_uid : upperState.user_id_doc2_uid;
                        params = {
                            digest: _arrayBufferToBase64(reader.result),
                            //  session_uid: upperState.session_uid,
                            name: file.name,
                            size: file.size,
                            target_uid: target
                        }
                        break;
                    case "pics":

                        params = {
                            digest: _arrayBufferToBase64(reader.result),
                            //  session_uid: upperState.session_uid,
                            name: file.name,
                            size: file.size,
                            target_uid: upperState.uid,
                            deal_uid: upperState.deal_uid
                        }
                        break;
                }
                fetch("/upload/a3bd943733384f37a38930554c9258b2/" + upperState.session_uid, {
                    method: "POST",
                    //   headers: { "Content-Type": "application/octet-stream" },
                    headers: { "Content-Type": "application/x-www-form-urlencoded" },

                    //  body: reader.result,
                    body: new URLSearchParams(params)
                })
                    .then((response) => response.json())
                    .then((result) => {
                        const new_ftf = filesToFilter.slice(1);
                        console.log("a00");
                        setFilesToFilter(new_ftf);
                        console.log("a000");
                        switch (result.res) {

                            case "ok":

                                file = Object.assign(file, { preview: URL.createObjectURL(file), status: 0, uid: result.uid });
                                setClearedFiles(Array(...clearedFiles, file));
                                break;

                            case "err":

                                file = Object.assign(file, { reason: result.reason });
                                setRejectedFiles(Array(...rejectedFiles, file));
                                break;
                        }
                    })
                    .catch((error) => {

                    });
            };

            reader.onerror = function () {
                console.log(reader.error);
            };

        }
    }, [filesToFilter]);

    const cb_cp4 = useEffect(() => {
        console.log("cb_cp4")
        if (clearedFiles !== undefined && clearedFiles.length > 0 && filesToFilter.length === 0) {
            processFiles();
        }
    }, [filesToFilter]);

    const processFiles = () => {
        console.log("processFiles")
        // let offset = clearedFiles.length;
        //let undone = clearedFiles.filter((f) => { return f.status === 0 });
        let fls = clearedFiles.map((file, idx) => Object.assign(file, {
            preview: URL.createObjectURL(file), status: 0, rg: idx
        }));
        fetch("/upload/44397fa145684e50afec007a7539fd8f/" + upperState.session_uid + "/" + (clearedFiles.length))
            .then((response) => response.json())
            .then((result) => {
                switch (result.res) {
                    case "ok":
                        console.log("updated session total files");
                        let fls = clearedFiles.map((file, idx) => Object.assign(file, {
                            rg: idx
                        }));
                        setClearedFiles(fls);

                        setState("upload");
                        // setClearedFiles((previousFiles) =>
                        //     previousFiles.concat(fls));
                        break;
                }
            })
            .catch((error) => {

            });
    }

    return (
        <Stack spacing={1}>
            {rejectedFiles.length > 0 && <Paper>
                <Alert

                    severity={"error"}
                    //icon={<HighlightOffIcon color="primary" />} 
                    icon={false}
                    action={<div style="height: 100%; display: flex; align-items: center; "><Button variant="contained" onClick={() => setRejectedFiles([])}>OK</Button></div>}
                >
                    <Stack>
                        <Typography variant="h5"> Certains éléments n'ont pas été acceptés:</Typography>
                        {rejectedFiles.map((f) => {
                            return <Box display={"flex"} justifyContent="space-between" alignItems={"center"}>
                                <Box style="padding-right: 8px; min-width: 100px;">
                                    <Typography noWrap={true}>{f.name}</Typography>
                                    <Chip color="error" label={f.reason} size={"small"} />
                                </Box>
                                <Box ></Box>
                            </Box>
                        })}

                    </Stack>
                </Alert>
            </Paper>}

            {clearedFiles.length === 0 && <Paper>
                <Dropzone
                    maxFiles={max ? max : 20}
                    onDrop={acceptedFiles => {
                        if (outerSetState !== undefined) {
                            outerSetState((current_state) => ({ ...current_state, is_uploading: true }));
                        }
                        setFilesToFilter(acceptedFiles);

                    }}>
                    {({ getRootProps, getInputProps }) => (
                        <section style="border-color: red;  border-width: 3px; border-style: dashed;   border-radius: 8px;">
                            <div {...getRootProps()} style="cursor: pointer; padding: 10px; background-color: rgba(255, 52, 38, 0.08);" >

                                <input {...getInputProps()} />

                                <Box display={"flex"} justifyContent={"space-evenly"} alignItems={"center"}>
                                    <Box p={1}>
                                        <CloudUploadIcon color="primary" fontSize={"large"} />
                                    </Box>
                                    <Box p={1}>
                                        <Typography>Cliquez ici pour chercher vos </Typography>
                                        <Typography>fichiers ou glissez-déplacez les ici</Typography>
                                        <Typography variant="h5">Fichier acceptés:
                                            {mode === "pics" && "Jpeg, TIFF, PNG, Max 30"}
                                            {mode === "iddoc" && "Jpeg, TIFF, PNG, PDF"}
                                            {mode === "docs" && "Max 10"}
                                        </Typography>
                                        <Typography variant="h5">
                                            {mode === "pics" && "Taille max: 30 images de 10 Mo max"}
                                        </Typography>
                                    </Box>
                                    <Box p={1}>
                                        <CloudUploadIcon color="primary" fontSize={"large"} />
                                    </Box>
                                </Box>
                            </div>
                        </section>
                    )}
                </Dropzone>
            </Paper>}
            <Paper style="margin-top: 10px; padding: 5px;">
                {clearedFiles.length > 0 && <Stack>
                    {
                        clearedFiles.map((f, idx) => {
                            console.log(f);
                            return (<Box display={"flex"} justifyContent="space-between" alignItems={"center"}>
                                <Box>
                                    <Box display={"flex"} justifyContent="flex-start" alignItems={"center"}>
                                        <Box p={1}>
                                            {f.type.startsWith('image/') && <img
                                                src={f.preview}
                                                //style={img}
                                                style="width: 75px; height: 75px;"
                                                // Revoke data uri after image is loaded
                                                onLoad={() => { URL.revokeObjectURL(f.preview) }}
                                            />}
                                        </Box>
                                        <Box p={1}>
                                            <Typography variant="h5">{f.name}</Typography>
                                        </Box>
                                    </Box>
                                </Box>
                                <Box>
                                    {f.status === 2 && <Typography variant="h5" sx={{ color: "red" }}>{errors[f.uid]}</Typography>}
                                    {f.status === 1 && <Typography variant="h5" sx={{ color: "green" }}><CloudUploadIcon /></Typography>}
                                    {/* {f.status === 1 && <Typography variant="h5" sx={{ color: "green" }}>Succès</Typography>} */}
                                    {f.status === 0 && (currentUploadingFile === undefined || f.rg !== currentUploadingFile.rg) && <Typography>En attente</Typography>}
                                    {f.status === 0 && currentUploadingFile && f.rg === currentUploadingFile.rg && progress !== 100 && <CircularProgressWithLabel value={progress[f.uid]} />}
                                </Box>
                            </Box>)

                        })}
                </Stack>
                }
                {false && clearedFiles.length === 0 && <Typography><em>Aucun fichier en cours de transfert</em></Typography>}
            </Paper>

        </Stack >
    );

}